import { channelIconElement } from '../../components/ChannelLegendItem'
import { getChannelColor } from '../../components/charts'
import type { BarChartSeries } from '../../components/MetricChart'
import type { ChannelTimeSeries } from '../hooks/useAllChannelsTimeSeries'

export function toPostsStackedBarSeries(
  displayedChannels: ChannelTimeSeries[],
  paletteIndexById: Map<string, number>,
): BarChartSeries[] {
  return displayedChannels.map((channel) => ({
    key: `posts-${channel.channel.id}`,
    label: channel.channel.name,
    color: getChannelColor(paletteIndexById.get(channel.channel.id) ?? 0),
    icon: channelIconElement(channel.channel.service),
    data: channel.primary.posts.map((point) => ({
      date: point.date,
      value: point.value,
    })),
  }))
}
